import { Card } from 'components/forms'
import styled, { css } from 'styled-components'

export const StickyCard = styled.div`
  background-color: var(--the-white);
  padding: 0;
  width: 100%;
  padding: 0;
  max-width: 752px;
  margin-top: 24px;
`

export const Container = styled.div`
  margin-top: 0;
`

export const InfoCard = styled(Card)`
  width: 100%;
  min-height: 89px;
  opacity: 1;
  position: relative;
  margin-bottom: -16px;
  border-radius: 2.4rem;
  ${props => props.expanded && (`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0;
  `)}
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  max-width: 752px;
`

export const InfoCardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
 ${props => props.expanded && css`
    border-bottom: 1px solid var(--silver);
    padding-bottom: 24px;
 `};
  svg {
    margin-left: auto;
  }
`

export const InfoCardTitle = styled.div`
  h2 {
    font-size: 16px;
    margin: ${props => props.margin ? '16px 0' : '0'};
    color: #222;
  }
`

export const Photo = styled.div`
  ${props => props.size ? `min-width: ${props.size}px; min-height: ${props.size}px;` : 'min-width: 40px; min-height: 40px;'}
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-image: url("${props => props.src}");
  background-size: ${({ setDefaultPhoto }) => setDefaultPhoto ? 'contain' : 'cover'};
  background-repeat: no-repeat;
  background-position: center center;
`

export const Summary = styled.div`
    font-size: 12px;
    color: var(--gray-5);
    font-family: var(--primary-font);
`

export const Pet = styled.div`
    font-family: var(--primary-font);
    color: var(--gray-2);
    white-space: nowrap;
    overflow: hidden;
    p.pet-name {
      font-size: 16px;
      font-weight: 600;
      line-height: 120%;
    }

    p.pet-breed-name {
      font-size: 13px;
      font-weight: 400;
      color: var(--gray-5);
      line-height: normal;
    }
`

export const WarningStatus = styled.span`
    img {
        position: absolute;
        margin-left: 4px;
        margin-top: 4px;
    }
`

export const Chevron = styled.div`
  position: absolute;
  right: 19px;
`

export const ExpandedInfo = styled.div`
  position: relative;
  padding: 16px;
  padding-top: 0;
  display: ${props => props.expanded ? 'block' : 'none'};
  background: var(--the-white);
  border: 1px solid var(--silver);
  border-top: none;
  border-radius: 0px 0px 16px 16px;
  z-index: 0;
  transition: 0.25s;
  width: 100%;
  margin: 16px 0;
  * {
      opacity: ${props => props.expanded ? '100%' : '0%'};
  }
  > h2 {
    color: var(--gray-2);
    font-family: var(--primary-font);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.2px;
  }
`

export const CurrentSchedule = styled.div`
    margin: 0;
    padding-bottom: 8px;
    display: ${props => props.expanded ? 'block' : 'none'};
    margin-bottom: 16px;
    border-bottom: ${props => props.firstPet ? 'none' : '1px solid var(--silver)'};
`

export const Price = styled.div`
    font-family: var(--primary-font);
    font-weight: 600;
    line-height: 145%;
    display: ${props => props.campaign ? 'flex' : 'block'};
    font-size: ${props => props.campaign ? '16px' : '13px'};
    margin-top: ${props => props.marginTop ? '4px' : '0px'};
    color: ${props => props.previousPrice ? 'var(--gray-5)' : 'var(--gray-2)'};
    ${props => props.previousPrice && 'text-decoration: line-through; font-weight: 400;'};

    ${({ price }) => price && css`
      color: var(--gray-5);
      font-size: 14px;
    `}
`

export const DiscountAmount = styled.div`
    background: var(--the-white);
    border-radius: 8px;
    margin-left: 8px;
    padding: 2px 8px;
    color: var(--success);
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17.7px;
    border: 1px solid var(--success);
`

export const CalcPrice = styled.div`
    display: ${props => props.expanded ? 'flex' : 'none'};
    align-items: center;
    padding-left: 8px;
    gap: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    color: var(--gray-2);
`
export const Total = styled.div`
    margin-left: auto;
    text-align: right;
    font-weight: 600;
    font-size: ${props => props.previousPrice ? '16px' : '20px'};
    ${props => props.previousPrice && 'text-decoration: line-through; margin-bottom: 4px;'};
`

export const Hr = styled.hr`
    background-color: var(--silver);
    height: 1px;
    border: none;
 `

export const Edit = styled.img`
    position:relative;
    margin-left: auto;
    cursor: pointer;
    z-index: 10;
`

export const WrapperPricesAndAnotherSchedulings = styled.div`
  display: flex;
  flex-direction: column;

  ${({ finalStep }) => finalStep && css`
    flex-direction: column-reverse;
  `}
`
